import React from 'react';
import { Field } from 'react-final-form';
import { Form as ToolkitForm } from '@contently/toolkit';
const { Label, Checkbox, ErrorWrapper } = ToolkitForm;
import styled from '@emotion/styled';

const PaddedInputs = styled('div')`
  min-height: 75px;
`;

const TargetField = (props) => {
  const { name, type, required, label, formData, parse, format } = props;

  const RenderInput = ({ input, meta }) => {
    return (
      <PaddedInputs>
        <Label required={required}>{label}</Label>
        <ErrorWrapper touched={meta.touched} error={meta.error}>
          <Checkbox {...input}></Checkbox>
        </ErrorWrapper>
      </PaddedInputs>
    );
  };

  return (
    <Field
      name={name}
      type={type}
      format={format}
      parse={parse}
      render={RenderInput}
      initialValue={formData[name]}
    />
  );
};

export default TargetField;



// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/prompts/TargetField.jsx